import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { TbCircleLetterAFilled } from "react-icons/tb";
import { RiDownloadCloudFill } from "react-icons/ri";
import Papa from "papaparse";
import { TbTableOptions } from "react-icons/tb";
import { IoSearch } from "react-icons/io5";
import axios from 'axios';
import { IoIosClose } from "react-icons/io";
import { IoIosArrowDropdown } from "react-icons/io";
import { IoCopy } from "react-icons/io5";
import Menu_Items from '../Menu_Items';


function API_In_Bound() {
    const { id, int_id } = useParams();

    const [su_admin, setsu_admin] = useState(false)
    const [admin, setadmin] = useState(false)
    const [API_details, setAPI_details] = useState([]);
    const [import_header, setimport_header] = useState([]);
    const [selected_header, setselected_header] = useState([]);
    const [alltables, setalltables] = useState([]);
    const [table_fields, settable_fields] = useState([]);
    const [value_none, setvalue_none] = useState([]);
    const [values, setvalues] = useState([]);
    const [search_file_headers, setsearch_file_headers] = useState('');
    const [search_header_mapping, setsearch_header_mapping] = useState('');
    const [header_mapping, setheader_mapping] = useState([]);
    const [values_mapping, setvalues_mapping] = useState([]);
    const [condition_deatils, setcondition_deatils] = useState([]);
    const [table_model, settable_model] = useState(false);
    const [file, setFile] = useState(null);
    const [sequence_no, setsequence_no] = useState('');
    const [update_status, setupdate_status] = useState(false);
    const [end_point_url, setend_point_url] = useState(``);

    const menus = [
        {
            name: 'Integrations',
            id
        },
        {
            name: 'In Bound',
            id,
            submenu: [
                { name: 'Schedule', id, int_id, type: 'In' },
                { name: 'API', id, int_id },
                { name: 'Manual', id, int_id }
            ]
        },
        (su_admin || admin ? { name: 'Users', id } : { name: null, id })
    ];

    const get_In_Bound_files = async () => {
        const number = Math.floor(10000000 + Math.random() * 90000000);
        setsequence_no(`${number}`);
        await axios.get(`/in_bound/api_details/files/tables/${int_id}`).then((res) => {
            const { details, tables, file_data } = res.data;
            setalltables(tables);
            if (details) {
                if (file_data) {
                    const keynames = file_data.flatMap(Object.keys);
                    setimport_header([...new Set(keynames)]);
                    setvalues(file_data);
                }
                if (details.headers_map) {
                    let headers_map = JSON.parse(details.headers_map);
                    setheader_mapping(headers_map);
                    let selected_Headers = headers_map.map((obj) => Object.keys(obj)[0]);
                    setselected_header(selected_Headers);
                }
                if (details.values_map) {
                    setvalues_mapping(JSON.parse(details.values_map));
                }
                if (details.condition && JSON.parse(details.condition).length > 0) {
                    let condition = JSON.parse(details.condition);
                    setcondition_deatils(condition);
                    let selected_tables = condition.map((obj) => Object.keys(obj)[0]);
                    selected_tables.forEach(table => {
                        handle_table(table);
                    });
                }
                else {
                    if (details.headers_map) {
                        let headers_map = JSON.parse(details.headers_map);
                        const tableNames = [...new Set(headers_map.map(obj => Object.values(obj)[0].table))];
                        tableNames.forEach(table => {
                            handle_table(table);
                        });
                    }
                }
                setAPI_details(details);
                setupdate_status(true);
                const baseName = details.file_name.substring(0, details.file_name.lastIndexOf("."));
                setend_point_url(`${process.env.REACT_APP_SERVER_FULL_URL}/in_bound/api/insert_data/${baseName}/${int_id}`);
            }
            else {
                setend_point_url(`${process.env.REACT_APP_SERVER_FULL_URL}/in_bound/api/insert_data/${number}/${int_id}`);
            }

        }).catch((err) => {
            toast.error('Error', {
                autoClose: 2000
            });
        })
    };
    const hadle_file = async (e) => {
        setFile(e.target.files[0]);
        const file = e.target.files[0];
        if (!file) return;
        const json_reader = new FileReader();
        const csv_reader = new FileReader();
        csv_reader.onload = (event) => {
            const csvData = event.target.result;
            // Parse CSV data
            Papa.parse(csvData, {
                header: true, // Adjust based on whether your CSV has headers
                skipEmptyLines: true,
                complete: (result) => {
                    const keynames = result.data.flatMap(Object.keys);
                    setimport_header([...new Set(keynames)]);
                    setvalues(result.data);
                    setselected_header([]);
                    setvalues_mapping([]);
                    setheader_mapping([]);
                },
            });
        };
        json_reader.onload = (e) => {
            const content = e.target.result;
            const keynames = JSON.parse(content).flatMap(Object.keys);
            setimport_header([...new Set(keynames)]);
            setvalues(JSON.parse(content));
            setselected_header([]);
            setvalues_mapping([]);
            setheader_mapping([]);
        };
        if (file.type === "application/json") {
            json_reader.readAsText(file);
        }
        else if (file.type === "text/csv") {
            csv_reader.readAsText(file);
        }
    };
    const handle_header = (header) => {
        const exist = selected_header.includes(header);
        if (exist) {
            setselected_header(prev =>
                prev.filter(h => h !== header)
            );
        }
        else {
            setselected_header([...selected_header, header]);
        }
        setheader_mapping((prevdata) => prevdata.filter((obj) => obj[header] ? !obj[header] : obj));
        setvalues_mapping((prevdata) => prevdata.filter((obj) => obj[header] ? !obj[header] : obj));
    };
    const handleDragStart = (event, index) => {
        event.dataTransfer.setData("text/plain", index); // Store the index of the dragged item
    };
    const handleDrop = (event, dropIndex) => {
        const dragIndex = event.dataTransfer.getData("text/plain"); // Get the index of the dragged item
        const updatedHeaders = [...selected_header];

        // Move the dragged item to the new position
        const [movedItem] = updatedHeaders.splice(dragIndex, 1);
        updatedHeaders.splice(dropIndex, 0, movedItem);

        // Update the state
        setselected_header(updatedHeaders);
    };
    const handleDragOver = (event) => {
        event.preventDefault(); // Prevent default to allow drop
    };
    const handle_header_mapping = (file_header, e) => {
        const value = e.target.value;
        const [tname, header] = value.split(' --- ');
        // const exist = table_fields.some(item => table in item);
        // setheader_mapping
        const exist = header_mapping.some(item => file_header in item);

        if (!exist) {
            setheader_mapping(prevdata => [...prevdata, { [file_header]: { 'table': tname, 'header': header } }])
        }
        else {
            setheader_mapping((prevdata) => prevdata.map((obj) => {
                return obj[file_header] ? { [file_header]: { 'table': tname, 'header': header } } : obj
            }));
        }

    };
    const v_none = (vfield) => {
        const exist = value_none.includes(vfield);
        if (!exist) {
            setvalue_none([vfield]);
        }
        else {
            setvalue_none((prevdata) => prevdata.filter((val) => val !== vfield));
        }

    };
    const handle_value_mapping_input = (field, e) => {
        const { id, value } = e.target;
        if (value !== '') {
            const field_exist = values_mapping.some(item => field in item);

            if (field_exist) {
                setvalues_mapping((prevdata) =>
                    prevdata.map((obj) => {
                        if (field in obj) {
                            return {
                                ...obj,
                                [field]: obj[field].map((item) => {
                                    if (item.old === id) {
                                        return { old: id, new: value }; // Update existing entry
                                    } else {
                                        return item; // Return unchanged entry
                                    }
                                }).concat(obj[field].some(item => item.old === id) ? [] : [{ old: id, new: value }]) // Add new entry if it doesn't exist
                            };
                        }
                        return obj;
                    })
                );
            } else {
                // Add new field with old and new values
                setvalues_mapping([...values_mapping, { [field]: [{ old: id, new: value }] }]);
            }
        }
    };
    // File Headers
    const file_headers = import_header.filter(header =>
        header.toLowerCase().startsWith(search_file_headers.toLowerCase())
    );
    // Selected Headers
    const Selected_headers = selected_header.filter(header =>
        header.toLowerCase().startsWith(search_header_mapping.toLowerCase())
    );
    const handle_con_table = (tname, k_name, value) => {
        // console.log('tname',tname);
        // console.log('k_name',k_name);
        // console.log('value',value);

        const exist = condition_deatils.some((item) => tname in item);
        if (!exist) {
            setcondition_deatils(prevdata => [...prevdata, { [tname]: { [k_name]: value } }]);
        }
        else {
            setcondition_deatils((prevdata) =>
                prevdata.map((obj) => {
                    if (obj[tname]) {
                        return {
                            ...obj,
                            [tname]: {
                                ...obj[tname],
                                [k_name]: value
                            }
                        };
                    }
                    return obj;
                })
            );

        }
    };
    const handle_table = async (table) => {
        const exist = table_fields.some(item => table in item); // Check if the table exists in the current state

        if (!exist) {
            try {
                // Make the axios call to post data
                await axios.get(`/in_bound/fields/${table}/${int_id}`).then((res) => {
                    let fields = res.data.map((obj) => {
                        return obj.Field;
                    });
                    // Update the state after the axios call resolves
                    settable_fields(prevdata => [...prevdata, { [table]: fields }]);

                })
                    .catch((err) => {
                        console.log('error');
                    });

            } catch (err) {
                toast.error('Error', {
                    autoClose: 2000
                });
            }
        } else {
            // If the item exists, filter it out and update the state
            settable_fields(prevdata => prevdata.filter(item => !(table in item)));
        }
    };
    const selected_condition = (tname, key) => {
        let value = condition_deatils.filter((obj) => obj[tname]);
        if (value.length > 0) {
            return value[0][tname][key];
        }

    };
    const retrive_field_mapping = (header) => {
        let field_map_values = header_mapping.filter((obj) => obj[header] ? obj[header] : '');
        if (field_map_values.length > 0) {
            return field_map_values[0][header];
        }
        else {
            return { table: "", header: '' }
        }


    };
    const field_mapping_add_submit = async () => {
        let formData = new FormData();
        const fileName = file.name; // Get the file name
        const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
        const value = {
            com_id: id,
            integ_id: int_id,
            file_name: `API${sequence_no}.${extension}`,
            condition: condition_deatils,
            values_map: values_mapping,
            headers_map: header_mapping
        };
        formData.append("sample_file", file);
        formData.append("values", JSON.stringify(value));
        formData.append("filename", `API${sequence_no}`);
        await axios.post(`/in_bound/add/api`, formData).then((res) => {
            setupdate_status(true);
            toast.success(res.data, {
                autoClose: 2000, // 2 seconds
            });
            // navigate(`/in_bound_details/${id}/${int_id}`);
        }).catch((err) => {
            console.log(`error`);
        });

    };
    const field_mapping_update_submit = async () => {
        if (file) {
            let formData = new FormData();
            formData.append("sample_file", file);
            formData.append("filename", `${API_details.file_name}`);
            await axios.post(`/in_bound/sample_file`, formData).then((res) => {
                toast.success(res.data, {
                    autoClose: 2000, // 2 seconds
                });
            })
                .catch((err) => {
                    console.log(`error`);
                });
        }
        const value = {
            condition: condition_deatils,
            values_map: values_mapping,
            headers_map: header_mapping
        };
        await axios.patch(`/in_bound/update/api/${API_details.id}`, value).then((res) => {
            toast.success(res.data, {
                autoClose: 2000
            });
        })
            .catch((err) => {
                toast.error('Error From field_mapping_update_submit', {
                    autoClose: 2000
                });
            });
    };
    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(end_point_url);
            toast.success('End Point URL Coiped', {
                autoClose: 2000
            });
        } catch (err) {
            toast.error('End Point URL Coiped Error', { autoClose: 2000 });
        }
    };
    const get_level = () => {
        const level = Cookies.get("level");
        if (level === "Super Admin") {
            setsu_admin(true);
        }
        else if (level === 'Admin') {
            setadmin(true)
        }

    };
    useEffect(() => {
        get_In_Bound_files();
        get_level();
    }, []);

    return (
        <div className='container df fdc ac'>
            <Navbar />
            <div className='main_box df'>
                <Menu_Items menu={menus} />
                <div className='content df fdc ac'>
                    <div className='page_header df jb ac'>
                        <div className='w90 df ac'>
                            <TbCircleLetterAFilled className='page_icon db' />
                            <p>API</p>
                        </div>
                        <div className="w10 df">
                            <label htmlFor='m_file' className='w30'><RiDownloadCloudFill className='icon3' /></label>
                            <input type='file' accept='.csv,.json' id='m_file' style={{ display: "none" }} onChange={(e) => { hadle_file(e) }}></input>
                            <div className='w30'><IoCopy className='icon3 db' onClick={handleCopy} /></div>
                            <Link to={`#`} className='w30' ><TbTableOptions className='icon3 g' onClick={() => { settable_model(true) }} /></Link>
                        </div>
                    </div>
                    <div className='box df jc ac'>
                        <div className='t_box1'>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Import Headers</p>
                            </div>
                            <div className='box_search df jc ac b0100' key={'1'}>
                                <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                <input type='search' id='ser_table' placeholder='Search' value={search_file_headers} onChange={(e) => setsearch_file_headers(e.target.value)} />
                            </div>
                            <div className='h73 w100 df fdc ac b0100 white'>
                                {
                                    file_headers.length > 0 ? (file_headers.map((header, index) => {
                                        let Header = header.charAt(0).toUpperCase() + header.slice(1);
                                        return (
                                            <div key={`header${index}`} className='df gap h3 w80 ac cp'>
                                                <input type='checkbox' id={`${header}`} onChange={() => { handle_header(header) }} checked={selected_header.includes(header)} />
                                                <label htmlFor={`${header}`}>{Header}</label>
                                            </div>
                                        )
                                    })) : (
                                        <p className='no_Records h50 w100 df jc ac '>No results found</p>
                                    )
                                }
                            </div>
                        </div>
                        <div className='t_box2'>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Selected Headers</p>
                            </div>
                            <div className='box_search df jc ac b0100'>
                                <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                <input type='search' id='ser_table' placeholder='Search' value={search_header_mapping} onChange={(e) => setsearch_header_mapping(e.target.value)} />
                            </div>
                            <div className='h73 w100 df fdc ac b0100 white'>
                                {
                                    Selected_headers.length > 0 && Selected_headers.map((sheader, index) => {
                                        let SHeader = sheader.charAt(0).toUpperCase() + sheader.slice(1);
                                        return (
                                            <div
                                                key={`sh${sheader}`}
                                                className="df gap h3 w80 ac jb cp"
                                                draggable
                                                onDragStart={(event) => handleDragStart(event, index)}
                                                onDragOver={handleDragOver}
                                                onDrop={(event) => handleDrop(event, index)}
                                            >
                                                <label htmlFor={`${sheader}`}>{SHeader}</label>
                                                <IoIosClose className="r" onClick={() => handle_header(sheader)} />
                                            </div>
                                        );
                                    })
                                }

                            </div>
                        </div>
                        <div className='t_box3'>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Values Mapping</p>
                            </div>
                            <div className='box_search df jc ac b0100'>
                                <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                <input type='search' id='ser_table' placeholder='Search' />
                            </div>
                            <div className='h73 w100 df fdc ac b0100 of_a white'>
                                {
                                    selected_header.length > 0 && selected_header.map((sheader, index) => {
                                        let SHeader = sheader.charAt(0).toUpperCase() + sheader.slice(1);
                                        return (
                                            <div key={`value_mapping_${index}`} className="w80 cp" draggable onDragStart={(event) => handleDragStart(event, index)} onDragOver={handleDragOver} onDrop={(event) => handleDrop(event, index)}>
                                                <div className="df jb ac h3">
                                                    <label htmlFor={`${sheader}`} className="p">{SHeader}</label>
                                                    <IoIosArrowDropdown className="db" onClick={() => v_none(sheader)} />
                                                </div>
                                                <div className={value_none.includes(sheader) ? `show w100 df fdc jc of_a gap` : `hide`}>
                                                    {
                                                        values.length > 0 ? (
                                                            [...new Map(values.map((obj) => [obj[sheader], obj])).values()]
                                                                .sort((a, b) => (a[sheader] > b[sheader] ? 1 : -1)) // Sort in ascending order
                                                                .map((obj, index) => {
                                                                    if (obj[sheader]) {
                                                                        return (
                                                                            <div className="h7 w100 df fdc jb" key={`v_m_${index}`}>
                                                                                <label htmlFor={obj[sheader]} className="h2">{obj[sheader]}</label>
                                                                                <input type="search" id={obj[sheader]} className="b1 h4" onChange={(e) => { handle_value_mapping_input(sheader, e) }} />
                                                                            </div>
                                                                        );
                                                                    }
                                                                })
                                                        ) : (
                                                            <p className="no_Records h50 w100 df jc ac">No results found</p>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        );
                                    })
                                }

                            </div>
                        </div>
                        <div className='t_box4'>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Headers Mapping</p>
                            </div>
                            <div className='box_search df jc ac'>
                                <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                <input type='search' id='ser_table' placeholder='Search' value={search_header_mapping} onChange={(e) => setsearch_header_mapping(e.target.value)} />
                            </div>
                            <div className='h65 w100 df fdc ac of_a white'>
                                {
                                    Selected_headers.length > 0 && Selected_headers.map((sheader, index) => {
                                        let SHeader = sheader.charAt(0).toUpperCase() + sheader.slice(1);
                                        return (
                                            <div
                                                key={`header_mapping_${index}`}
                                                className="df gap h5 w90 ac jb cp"
                                                draggable
                                                onDragStart={(event) => handleDragStart(event, index)}
                                                onDragOver={handleDragOver}
                                                onDrop={(event) => handleDrop(event, index)}
                                            >
                                                <label className="w25" htmlFor={`${sheader}`}>{SHeader}</label>
                                                <select className="w50" key={`h_m${index}`} onChange={(e) => { handle_header_mapping(sheader, e) }}>
                                                    <option>Select Header</option>
                                                    {
                                                        table_fields.length > 0 && table_fields.map((obj) => {
                                                            return Object.values(obj)[0].map((fnam) => {
                                                                let tableName = Object.keys(obj)[0].charAt(0).toUpperCase() + Object.keys(obj)[0].slice(1);
                                                                let Fname = fnam.charAt(0).toUpperCase() + fnam.slice(1);
                                                                return (
                                                                    <option
                                                                        value={`${Object.keys(obj)[0]} --- ${fnam}`}
                                                                        selected={retrive_field_mapping(sheader).table === Object.keys(obj)[0] && retrive_field_mapping(sheader).header === fnam}
                                                                    >
                                                                        {Fname} - {tableName}
                                                                    </option>
                                                                );
                                                            });
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        );
                                    })
                                }

                            </div>
                            {
                                header_mapping.length > 0 && <div className='h8 w100 df jc ac white'>
                                    <button className='btn green' onClick={update_status ? field_mapping_update_submit : field_mapping_add_submit}>{update_status ? 'Update' : 'Submit'}</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {
                table_model && <div className='model'>
                    <div className='h70 w80 white br1 df jb ac'>
                        <div className='h70 w20 df fdc ac '>
                            <div className='h5 w100 df jc ac h_blue br_f_1 fs08 w'><p>Select Tables</p></div>
                            <div className='box_search df jc ac b0100' key={'1'}>
                                <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                <input type='search' id='ser_table' placeholder='Search' />
                            </div>
                            <div className='h60 w100 of_a b0100'>
                                {
                                    // 
                                    alltables && alltables.map((tnam) => {
                                        let tableName = tnam.charAt(0).toUpperCase() + tnam.slice(1);
                                        return (
                                            <div className='h3 pad0101 w100 df ac gap' key={tnam}>
                                                <input type='checkbox' id={tnam} onChange={() => { handle_table(tnam) }} checked={table_fields.some(item => tnam in item)} />
                                                <label htmlFor={tnam}>{tableName}</label>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className='h70 w80 df fdc ac'>
                            <div className='h5 w100 p df jc ac h_blue w br_l_1'><p>Set Conditions</p></div>
                            <div className='box_search df jc ac b0100' key={'1'}>
                            </div>
                            <div className='h50 w100 of_a df fdc gap ac'>
                                {table_fields.map((obj, index) => {
                                    let tablename = Object.keys(obj)[0].charAt(0).toUpperCase() + Object.keys(obj)[0].slice(1);
                                    return (
                                        <div className="h5 w100 df js ac" key={index}>
                                            <div className="df fdc jb h3 w25">
                                                <label>Primary Table</label>
                                                <select defaultValue={tablename}>
                                                    <option>{tablename}</option>
                                                </select>
                                            </div>
                                            <div className="df fdc jb h3 w25">
                                                <label>Primary Field</label>
                                                <select
                                                    value={selected_condition(Object.keys(obj)[0], 'field') || ''}
                                                    onChange={(e) => handle_con_table(Object.keys(obj)[0], 'field', e.target.value)}
                                                >
                                                    <option value="" disabled>Select Field</option>
                                                    {obj[Object.keys(obj)[0]].map((field, idx) => {
                                                        let Field = field.charAt(0).toUpperCase() + field.slice(1);
                                                        return (
                                                            <option key={idx} value={field}>
                                                                {Field}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                            <div className="df fdc jb h3 w25">
                                                <label>Primary File Header</label>
                                                <select
                                                    value={selected_condition(Object.keys(obj)[0], 'header') || ''}
                                                    onChange={(e) => handle_con_table(Object.keys(obj)[0], 'header', e.target.value)}
                                                >
                                                    <option value="" disabled>Select Header</option>
                                                    {file_headers.map((header, idx) => {
                                                        let Header = header.charAt(0).toUpperCase() + header.slice(1);
                                                        return (
                                                            <option key={idx} value={header}>
                                                                {Header}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>
                            <div className='h10 w80 df jc ac gap2'>
                                <button className='btn l_black' onClick={() => { settable_model(false); }}>Close</button>
                                <button className='btn green' onClick={() => { settable_model(false); }}>Submit</button>
                            </div>
                        </div>

                    </div>
                </div>
            }
        </div >
    )
}

export default API_In_Bound;